/* eslint-disable func-names */
/* eslint-disable no-undef */
const modal = () => {
  (function ($) {
    const $modal = $('.js-modal');
    const $closeButton = $('.js-modal-close-button');

    $closeButton.on('click', () => {
      $modal.hide();
    });
  }(jQuery));
};

export default modal;
